import util from '@/utils/util'

export const AVG_METRICS = ['bid_rate', 'imp_rate', 'click_rate', 'cpm_price']

export const MAIN_COLOR = '#3361FF'

// 画线的颜色
export const SERIES_COLORS = [
  '#3268D7', // 蓝
  '#FFB301', // 黄
  '#0B9D58', // 绿
  '#7B61FF', // 紫
  '#DB4437', // 红
  '#ED7B2F', // 橙
  '#00A3A3', // 青
  '#B03CC4', // 品红
  '#FF6EA8', // 粉
  '#4A5A78' // 深灰蓝
]

// 其他
export const OTHER_COLOR = '#A9AEB8'

// 指标卡片上小圆点的颜色
// 拖动换序时颜色要跟着卡片一起走
const METRIC_COLORS = {
  media_price: '#3361FF', // 蓝
  cpm_price: '#FF9A2E', // 橙
  imp: '#4DC9F6', // 天蓝
  rawreq: '#7B61FF', // 紫
  bid: '#00B42A', // 绿
  clk: '#F53F3F', // 红
  bid_rate: '#00A3A3', // 青
  imp_rate: '#B03CC4', // 品红
  click_rate: '#FF6EA8' // 粉
}

export function metricColor(key) {
  const hit = METRIC_COLORS[key]
  return hit || MAIN_COLOR
}

// 区分计数类、金额类、比率类指标
export function metricUnit(key) {
  const str = String(key === undefined || key === null ? '' : key)
  if (str.substring(str.length - 5) === '_rate') return 'rate'
  if (str.substring(str.length - 5) === 'price') return 'money'
  return 'count'
}

export function isAvgMetric(key) {
  return AVG_METRICS.indexOf(String(key)) !== -1
}

function isBlank(val) {
  return val === undefined || val === null || val === ''
}

// 金额类固定两位小数，前面加 $，千分位
export function formatMoney(val) {
  const num = Number(val) || 0
  const fixed = Math.abs(num).toFixed(2)
  const dot = fixed.indexOf('.')
  const sign = num < 0 ? '-' : ''
  return sign + '$' + util.commafy(fixed.substring(0, dot)) + fixed.substring(dot)
}

// 比率类表示方式
export function formatRate(val) {
  if (isBlank(val)) return '-'
  return (Number(val) || 0).toFixed(2) + '%'
}

// 计数类保持千分位
export function formatCount(val) {
  if (isBlank(val)) return '-'
  return util.commafy(val)
}

// 卡片数值、图表图例、tooltip 共用的格式化
export function formatMetric(key, val) {
  if (isBlank(val)) return '-'
  const unit = metricUnit(key)
  if (unit === 'rate') return formatRate(val)
  if (unit === 'money') return formatMoney(val)
  return formatCount(val)
}

// 缩写单位，中英文统一按 K / M / B（海外场景）
const ABBR_STEPS = [[1e9, 'B'], [1e6, 'M'], [1e3, 'K']]

// 计数类的数字要表示成 73.3M 这种形式，小于 1 万的数字就不缩写
const CARD_ABBR_MIN = 10000

function formatCardCount(val) {
  const num = Number(val) || 0
  const abs = Math.abs(num)
  const sign = num < 0 ? '-' : ''
  if (abs < CARD_ABBR_MIN) return sign + util.commafy(String(Math.round(abs)))
  for (let i = 0; i < ABBR_STEPS.length; i++) {
    if (abs >= ABBR_STEPS[i][0]) {
      // 除不尽留一位小数（73,335,000 → 73.3M），整数不补 .0（100,000 → 100K）
      return sign + trimZeros((abs / ABBR_STEPS[i][0]).toFixed(1)) + ABBR_STEPS[i][1]
    }
  }
  return sign + util.commafy(String(Math.round(abs)))
}

// 卡片专用：金额和比率与别处一致（$1,234.56 / 80.25%），只有计数类要缩写
export function formatCardMetric(key, val) {
  if (isBlank(val)) return '-'
  const unit = metricUnit(key)
  if (unit === 'rate') return formatRate(val)
  if (unit === 'money') return formatMoney(val)
  return formatCardCount(val)
}

function trimZeros(str) {
  if (str.indexOf('.') === -1) return str
  return str.replace(/0+$/, '').replace(/\.$/, '')
}

// 刻度值按量级缩写。除不尽时留一位小数（15,500 → 15.5K），整数不补 .0
function abbrAxis(abs) {
  for (let i = 0; i < ABBR_STEPS.length; i++) {
    if (abs >= ABBR_STEPS[i][0]) {
      return trimZeros((abs / ABBR_STEPS[i][0]).toFixed(1)) + ABBR_STEPS[i][1]
    }
  }
  // 到不了缩写门槛就照常千分位。上千的抹掉小数，轴上不需要看到分；
  if (abs >= 1000) return util.commafy(String(Math.floor(abs)))
  return trimZeros(abs.toFixed(2))
}

// chart纵轴的表示方式：比利率的纵轴要加上%，金额类的加上$符号，并且要按照缩写进行展示
export function formatAxis(key, val) {
  if (isBlank(val)) return ''
  const unit = metricUnit(key)
  if (unit === 'rate') return val + '%'
  const num = Number(val) || 0
  const sign = num < 0 ? '-' : ''
  return sign + (unit === 'money' ? '$' : '') + abbrAxis(Math.abs(num))
}
